module.exports = __webpack_public_path__ + "img/groovepay-integration.4684c118.png";